import React, { Component, PropTypes } from 'react';
import { Form, Layout, Row, Col } from 'antd';
import NHFormItem from "../../../common/NHFormItem";
import css from './show.css';
import ColStudents from "./RowStudents";

const { Header, Footer, Sider, Content } = Layout;


class StudentsInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        let formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        const { showData } = this.props;
        { console.log('showData', this.props.showData); }

        return (
            <div>
                <Row>
                    <Col span={16}>
                        <div>
                            <Row>
                                <Col span={12}>
                                    <ColStudents name={"姓名"} param={showData.XM} />
                                </Col>
                                <Col span={12}>
                                    <ColStudents name={"性别"} param={showData.XB} />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <ColStudents name={"考生号"} param={showData.KSH} />
                                </Col>
                                <Col span={12}>
                                    <ColStudents name={"准考证号"} param={showData.ZKZH} />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <ColStudents name={"一卡通"} param={showData.YKT} />
                                </Col>
                                <Col span={12}>
                                    <ColStudents name={"学号"} param={showData.XH} />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div style={{ height: 162 }}>
                            <Row >
                                <Col span={9} className={css.photo_left}></Col>
                                <Col span={15} className={css.photo_right}>
                                    <img style={{ width: 136, height: 160 }} src={'api/sm-student/openapi/getStudentPhoto?xsid=' + showData.XSID+'&type=10'} />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"录取号"} param={showData.LQH} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"身份证号"} param={showData.SFZJH} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"学生类型"} param={showData.XSLB} />
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"政治面貌"} param={showData.ZZMM} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"出生日期"} param={showData.CSRQ} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"联系电话"} param={showData.SJHM} />
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"院系"} param={showData.BMMC} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"专业"} param={showData.ZYMC} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"班级"} param={showData.BJMC} />
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"银行卡号"} param={showData.YHKH} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"生源地"} param={showData.SSQMC} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"民族"} param={showData.MZ} />
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"高考分数"} param={showData.GKFS} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"籍贯"} param={showData.JG} />
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"是否报到"} param={showData.SFBD} />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <ColStudents span={[3, 21.5]} hieght={100} name={"家庭地址"} param={showData.JTDZ} />
                    </Col>
                </Row>
            </div>
        );
    }
}
const StudentsInfoShow = Form.create()(StudentsInfo);
export default StudentsInfoShow;


// WEBPACK FOOTER //
// ./components/tjcx/queryStudents/gyQueryStudents/show.js